import React, { useEffect, useState } from "react";
import { fetchServices } from "@/lib/api";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import LogoMarquee from "@/components/site/LogoMarquee";
import Services from "@/components/site/Services";
import Features from "@/components/site/Features";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";

export default function LandingPage() {
  const [services, setServices] = useState([]);
  const [selectedSlug, setSelectedSlug] = useState(null);

  useEffect(() => {
    fetchServices()
      .then((data) => setServices(data))
      .catch((e) => console.error("Failed to load services", e));
  }, []);

  const handleSelectService = (slug) => {
    setSelectedSlug(slug);
    const el = document.getElementById("booking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-[#050505] text-zinc-200 min-h-screen overflow-x-hidden">
      <Navbar />
      <Hero />
      <LogoMarquee />
      <Services services={services} onSelect={handleSelectService} />
      <Features />
      <Gallery />
      <Testimonials />
      <Booking services={services} selectedSlug={selectedSlug} setSelectedSlug={setSelectedSlug} />
      <Footer />
    </div>
  );
}
